import { Breakpoint } from './const.theme';
import type { ShortBreakpointKey } from './mapResponsiveStyleProp';

/**
 * Used for GridThemeProvider of styled-bootstrap-grid, defaults are:
    xxl: 1440,
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 575,
 */

export const gridTheme: {
  breakpoints: Record<ShortBreakpointKey, number>;
} = {
  breakpoints: {
    // 1600
    xxl: Breakpoint.desktopLarge,
    // 1440
    xl: Breakpoint.desktop,
    // 1200
    lg: Breakpoint.desktopSmall,
    // 700
    md: Breakpoint.ipad,
    // 375
    sm: Breakpoint.iphone,
    xs: Breakpoint.iphone,
  },
};

export const generalCardNumSpacings = { xl: 64, lg: 48, md: 32, xs: 24 };
